import { vec3 } from 'gl-matrix';
export const SLAB_RELATIVE_EPSILON = 1e-5;
export function getSlabEpsilon(voxelThickness) {
    return Math.abs(voxelThickness) * SLAB_RELATIVE_EPSILON;
}
export function resolveReferencePlaneThickness(referencePlaneThickness, voxelThickness) {
    return Number.isFinite(referencePlaneThickness) &&
        referencePlaneThickness > 0
        ? referencePlaneThickness
        : voxelThickness;
}
export function getMembershipHalfWidth(referencePlaneThickness, voxelThickness) {
    return (referencePlaneThickness + voxelThickness) / 2;
}
export function getFillHalfWidth(fillDepth, voxelThickness) {
    const depth = Number.isFinite(fillDepth) && fillDepth > 0
        ? fillDepth
        : 0;
    return Math.max(depth, Math.abs(voxelThickness)) / 2;
}
export function getSlabHalfWidth(thickness, voxelThickness, coverage = 'overlapping') {
    return coverage === 'centerInside'
        ? getFillHalfWidth(thickness, voxelThickness)
        : getMembershipHalfWidth(thickness, voxelThickness);
}
export function isSlabDepthLowInclusive(coverage = 'overlapping') {
    return coverage === 'centerInside';
}
export function getDisplayHalfWidth(viewportSlabThickness, referencePlaneThickness) {
    return (viewportSlabThickness + referencePlaneThickness) / 2;
}
export function signedDistanceToPlane(point, planePoint, normal) {
    return ((point[0] - planePoint[0]) * normal[0] +
        (point[1] - planePoint[1]) * normal[1] +
        (point[2] - planePoint[2]) * normal[2]);
}
export function isWithinSlab(signedDistance, halfWidth, epsilon) {
    return Math.abs(signedDistance) < halfWidth - epsilon;
}
export function isVoxelCenterInSlab(voxelCenter, planePoint, normal, referencePlaneThickness, voxelThickness) {
    return isWithinSlab(signedDistanceToPlane(voxelCenter, planePoint, normal), getMembershipHalfWidth(referencePlaneThickness, voxelThickness), getSlabEpsilon(voxelThickness));
}
export function projectPointOntoPlane(point, planePoint, normal, out = [0, 0, 0]) {
    const distance = signedDistanceToPlane(point, planePoint, normal);
    out[0] = point[0] - distance * normal[0];
    out[1] = point[1] - distance * normal[1];
    out[2] = point[2] - distance * normal[2];
    return out;
}
export function asUnitNormal(normal) {
    const lengthSquared = normal[0] * normal[0] + normal[1] * normal[1] + normal[2] * normal[2];
    if (Math.abs(lengthSquared - 1) < Number.EPSILON * 8) {
        return normal;
    }
    return vec3.normalize(vec3.create(), normal);
}
